/*
  Cart upsell "+ Add" handler.

  IMPORTANT — two assumptions baked in below, both flagged because this file
  doesn't have visibility into your theme's cart.js internals:

  1. SECTION_ID assumes the section that renders {% render 'cart-drawer' %}
     has the Shopify section id "cart-drawer" (Dawn's default naming). If
     your header section wraps it under a different section id, change the
     SECTION_ID constant below to match, or the refresh will fall back to a
     full page reload.

  2. After replacing the <cart-drawer> element with the freshly-rendered
     version, we try to keep the drawer visually open (since the customer
     just clicked something *inside* an open drawer) by copying over
     whatever "open" class/attribute the old element had, and calling an
     .open() method if the custom element exposes one. If your cart.js uses
     a different mechanism to track open/closed state, the drawer may
     visually close after adding — tell me what that mechanism is and I'll
     adjust this.
*/

(function () {
  const SECTION_ID = 'cart-drawer';

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    addUpsellItem(btn);
  });

  async function addUpsellItem(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled || btn.classList.contains('is-loading')) return;

    const originalText = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!addRes.ok) {
        const err = await addRes.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }

      await refreshCartDrawer();
    } catch (err) {
      console.error('Cart upsell add error', err);
      btn.classList.remove('is-loading');
      btn.textContent = originalText;
      alert('Could not add item to cart. Please try again.');
    }
  }

  async function refreshCartDrawer() {
    const oldDrawer = document.querySelector('cart-drawer');
    if (!oldDrawer) {
      window.location.reload();
      return;
    }

    // Remember whether the drawer was open before we replace it.
    const wasOpenClass = ['animate', 'active', 'is-open'].find((cls) =>
      oldDrawer.classList.contains(cls)
    );

    try {
      const res = await fetch(`${window.location.pathname}?sections=${SECTION_ID}`);
      if (!res.ok) throw new Error('Section fetch failed');

      const sections = await res.json();
      const html = sections[SECTION_ID];
      if (!html) throw new Error(`Section id "${SECTION_ID}" not found in response`);

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      if (!newDrawer) throw new Error('No <cart-drawer> element in refreshed markup');

      oldDrawer.replaceWith(newDrawer);

      // Try to keep the drawer visually open after the swap.
      if (typeof newDrawer.open === 'function') {
        newDrawer.open();
      } else if (wasOpenClass) {
        newDrawer.classList.add(wasOpenClass);
      }
    } catch (err) {
      console.error('Cart drawer refresh error, falling back to reload', err);
      window.location.reload();
    }
  }
})();